import { defineWidget } from '../widget-types';
import type { BlockNode } from '../block-types';

const productGridDefaultBlocks: BlockNode[] = [
  {
    id: 'product-grid-heading',
    type: 'text',
    content: { type: 'text', value: 'Our Products', fontSize: 28, fontWeight: 700, textAlign: 'left' },
    layout: { order: 0, widthPct: 100 },
  },
  {
    id: 'product-grid-subheading',
    type: 'text',
    content: { type: 'text', value: 'Browse our latest items', fontSize: 16, fontWeight: 400, textAlign: 'left' },
    layout: { order: 1, widthPct: 100 },
  },
];

export const productGridWidget = defineWidget({
  type: 'product-grid',
  schema: {
    label: 'Product Grid',
    description: 'Grid of product cards with configurable data source and count',
    props: {
      dataSource: {
        type: 'enum',
        label: 'Data Source',
        options: ['featured_products', 'latest_products', 'bestsellers', 'on_sale', 'products_by_category', 'products_by_collection'],
        default: 'featured_products',
        structural: true,
      },
      limit: {
        type: 'number',
        label: 'Number of products',
        min: 1,
        max: 50,
        default: 8,
        structural: true,
      },
      categoryHandle: {
        type: 'string',
        label: 'Category Handle',
        description: 'Required when data source is "products_by_category"',
        structural: true,
      },
      collectionSlug: {
        type: 'collection',
        label: 'Collection',
        description: 'Required when data source is "products_by_collection"',
        structural: true,
      },
      showHeaderLink: {
        type: 'boolean',
        label: 'Show Header Link',
        default: false,
      },
      headerLinkIcon: {
        type: 'icon',
        label: 'Header Link Icon',
        default: 'chevron-right',
      },
      headerLinkUrl: {
        type: 'link',
        label: 'Header Link URL',
      },
      /* ready-made card designs (utils/product-card-style) — set = the designed grid; absent = the original grid */
      cardDesign: {
        type: 'enum',
        label: 'Card design',
        options: ['classic', 'shop', 'minimal', 'boxed'],
      },
      layout: {
        type: 'enum',
        label: 'Layout',
        options: ['grid', 'row'],
        default: 'grid',
      },
      columns: { type: 'number', label: 'Columns (phone)', min: 1, max: 3, default: 2 },
      gapPx: { type: 'number', label: 'Gap (px)', min: 0, max: 48, default: 12 },
      imageShape: { type: 'enum', label: 'Image shape', options: ['square', 'tall'], default: 'square' },
      titleLines: { type: 'number', label: 'Name lines', min: 1, max: 2, default: 2 },
      showComparePrice: { type: 'boolean', label: 'Show old price', default: true },
      showAddToCart: { type: 'boolean', label: 'Add to cart button' },
      buttonColor: { type: 'color', label: 'Button colour' },
      buttonLabel: { type: 'string', label: 'Button text' },
    },
    slots: {
      heading: { type: 'text', label: 'Section Heading' },
      subheading: { type: 'text', label: 'Section Subheading' },
      headerLinkText: { type: 'text', label: 'Header Link Text' },
    },
    dataDeps: ['featuredProducts', 'newestProducts', 'bestsellers', 'onSale', 'productsByCategory', 'productsFromCollection'],
  },
  nameTh: 'ตารางสินค้า',
  descriptionTh: 'แสดงสินค้าในรูปแบบตารางพร้อมตั้งค่าจำนวนและแหล่งข้อมูล',
  category: 'products',
  thumbnail: '/widget-thumbnails/product-grid.svg',
  defaults: {
    type: 'product-grid',
    props: { dataSource: 'featured_products', limit: 8 },
    slots: {
      heading: { value: 'Our Products' },
    },
  },
  defaultBlocks: productGridDefaultBlocks,
});
